import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Calender } from '../../assets/icons/account-management/calender.svg';
import { ReactComponent as Facility } from '../../assets/icons/account-management/location.svg';
import { ReactComponent as UserTag } from '../../assets/icons/account-management/user-tag.svg';
import { useAppBranding } from '../../config/branding';
import { useAppDispatch } from '../../redux/hooks';
import { setNotificationMessage } from '../../redux/slices/NotificationManagementSlice';
import ToFixedValue from '../../shared-functions/ToFixedValue';
import accountApi from '../../utils/api/account';

import FacilityAccountList from './components/facility-account-list';

interface AccountManagementDataProperties {
  totalFoRevenue: number;
  totalAdminRevenue: number;
  totalFoProfit: number;
}

/**
 * Account Management function Component
 */
function AccountManagement() {
  const branding = useAppBranding();
  const { t } = useTranslation('account');
  const dispatch = useAppDispatch();
  const [accountManagementData, setAccountManagementData] =
    useState<AccountManagementDataProperties>({
      totalFoRevenue: 0,
      totalAdminRevenue: 0,
      totalFoProfit: 0,
    });

  /**
   * show for the Revenue and Admin share and facility share data
   */
  const fetchConsolidatedRevenueData = async () => {
    try {
      const response = await accountApi.fetchConsolidatedRevenue();
      setAccountManagementData(response.data);
    } catch (error: any) {
      dispatch(
        setNotificationMessage({
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || 'Something went wrong!',
          },
        }),
      );
    }
  };

  const summaryItems = [
    {
      label: `${t('facilityShare')}`,
      Icon: UserTag,
      value: accountManagementData.totalFoRevenue,
    },
    {
      label: `${t('AdminShare')}`,
      Icon: Calender,
      value: accountManagementData.totalAdminRevenue,
    },
    {
      label: `${t('facilityProfit')}`,
      Icon: Facility,
      value: accountManagementData.totalFoProfit,
    },
  ];

  useEffect(() => {
    fetchConsolidatedRevenueData();
  }, []);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <div className="container">
        <div className="header-title">
          {/* <h2>{t('facility')}</h2> */}
          <div className="facility-content">
            {summaryItems.map(({ label, Icon, value }, index) => (
              <React.Fragment key={label}>
                <div className="content">
                  <div className="svg">
                    <Icon />
                  </div>
                  <p className="label">{label}</p>
                  <div className="value">
                    <p className="icon">{branding.text.currency}</p>
                    <div className="line" />
                    <p>{ToFixedValue(value)}</p>
                  </div>
                </div>
                {index < summaryItems.length - 1 && <div className="right-line" />}
              </React.Fragment>
            ))}
          </div>
        </div>
        <div className="body-container">
          <div className="table-content">
            <FacilityAccountList />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountManagement;
